
import { useState } from "react";
import './styles.scss';
import { subscribeToNewsletter } from "../../api";

const Subscribe = ({ onClose }) => {
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsloading] = useState(false);

    const [state, setState] = useState({
        email: ""
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({ ...prev, [name]: value }));
    };

    const submitSubscribe = (e) => {
        e.preventDefault();
        setIsloading(true);
        subscribeToNewsletter(state).then((res) => {
            if (res.status === 200 || res.status === 204) {
                setIsSuccess(true);
                setIsError(false);
            } else {
                setIsError(true);
            }

            setIsloading(false);
        }).catch((error) => {
            setIsSuccess(false);
            setIsError(true);
            setIsloading(false);
        });
    };

    return (
        <div className='subscribe'>
            {onClose &&
                <div className='subscribe-modal-header'>
                    <div onClick={() => onClose()}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></div>
                </div>
            }

            <h2>Subscribe to our Newsletter</h2>
            <p>Get the latest news from our studio.</p>
            <input type='email' name="email" defaultValue="" onChange={(e) => handleInputChange(e)} placeholder='Email' />

            {onClose
                ? <div className="subscribe-modal-actions">
                    <button className={`cta gold-fill ${isLoading ? "loading" : ""}`} onClick={(e) => submitSubscribe(e)}>
                        <div className="loader"></div>
                        <span>Subscribe</span>
                    </button>
                </div>
                : <button className={`cta gold-fill ${isLoading ? "loading" : ""}`} onClick={(e) => submitSubscribe(e)}>
                    <div className="loader"></div>
                    <span>Subscribe</span>
                </button>}
            {isSuccess && <p className="success">Thank you! You are now subscribed.</p>}
            {isError && <p className="error">Unfortunately something went wrong. Please try again.</p>}
        </div>
    )
}

export default Subscribe;